module.exports = __webpack_public_path__ + "static/dc-orlando-4-0b348b59164cdf16770e3164cbf7a8bd.jpg";